import {
  aboutHighlights,
  buyerTypes,
  contact,
  dealerStats,
  enquiryTypes,
  faqs,
  heroStats,
  technology,
  timeline,
  whyChoose,
} from "./company";

export const defaultSiteContent = {
  metadata: {
    title: "evLUXE Electric Scooter Manufacturer in India | Dealer, Fleet & Export Enquiries",
    description:
      "Premium evLUXE electric scooters engineered in India for dealers, distributors, fleet buyers and export partners.",
  },
  navigation: [
    { id: "home", label: "Home" },
    { id: "models", label: "Models" },
    { id: "compare", label: "Compare" },
    { id: "technology", label: "Technology" },
    { id: "about", label: "About" },
    { id: "dealer", label: "Dealer Network" },
    { id: "contact", label: "Contact" },
  ],
  actions: {
    registerInterest: "Register Interest",
    viewModels: "View Models",
    compareModel: "Compare Model",
    viewSpecs: "View all specs",
    enquireWhatsApp: "Enquire on WhatsApp",
    availableColours: "Available colours",
    applyDealership: "Apply for Dealership",
    talkToSales: "Talk to Sales",
    viewMap: "View on Map",
    chatWhatsApp: "Chat on WhatsApp",
    continueWhatsApp: "Continue on WhatsApp",
    submitAnother: "Submit another enquiry",
    submitForm: "Send Enquiry on WhatsApp",
    submittingForm: "Opening WhatsApp...",
  },
  productLabels: {
    motor: "Motor",
    speedMeter: "Speed Meter",
    voltage: "Voltage",
    wheelRim: "Wheel Rim",
    batteryType: "Battery Type",
    brakingSystem: "Braking System",
    suspension: "Suspension",
    batteryAmpere: "Battery Ampere",
    tyreSize: "Tyres Size",
    maxLoading: "Max Loading",
  },
  hero: {
    kicker: "THE NEXT GENERATION",
    titleLine1: "evLUXE Electric",
    titleLine2: "Scooters",
    titleAccent: "Built for India",
    description:
      "Experience smart, eco-friendly mobility designed for Indian roads, dealer networks, fleet buyers and confident everyday electric commuting.",
    imageAlt: "evLUXE electric scooter riding through an Indian city",
    scrollLabel: "SCROLL",
    proofPoints: [
      { icon: "BatteryCharging", label: "Lead-acid and lithium-ion options" },
      { icon: "ShieldCheck", label: "Waterproof BLDC hub motor" },
      { icon: "MapPin", label: "Built for Indian roads" },
    ],
    stats: heroStats,
  },
  productsSection: {
    kicker: "ELECTRIC SCOOTERS",
    title: "Explore evLUXE Electric Scooters",
    description:
      "{count} precision-engineered {models}, each built for premium performance, dealership growth, fleet use and the realities of Indian roads.",
  },
  comparison: {
    kicker: "SIDE BY SIDE",
    title: "Compare evLUXE Models",
    description:
      "Select up to 3 models to compare specifications. Differences are highlighted in green.",
    empty: "Select at least one model to compare.",
    help: "Need help choosing?",
    specification: "Specification",
  },
  technologySection: {
    kicker: "TECHNOLOGY",
    title: "Engineered for the New Electric Era",
    description:
      "Every evLUXE scooter is built on a foundation of proven, dependable electric technology.",
    items: technology,
  },
  whySection: {
    kicker: "WHY evLUXE",
    title: "Redefining Premium Electric Mobility",
    description:
      "Crafting a new era of luxury, performance, and intelligent ride experiences.",
    items: whyChoose,
  },
  aboutSection: {
    kicker: "OUR LEGACY",
    title: "Built on Legacy. Driven by Innovation.",
    description:
      "From an automotive parts pioneer founded in 1960 to a future-ready EV manufacturer, evLUXE is built on six decades of trust and now engineers premium electric mobility in India, for India and the world.",
    visionPrefix: "Working on the vision of",
    vision1: "Make in India - Atmanirbhar Bharat",
    vision2: "Make in India for the World.",
    timeline,
    highlights: aboutHighlights,
  },
  dealerSection: {
    kicker: "PARTNER WITH US",
    title: "Join the evLUXE Dealer Network",
    description:
      "evLUXE is expanding across India with a strong distributor-dealer network for electric vehicles, from Tier-1 metros to Tier-4 towns. Partner with a brand built on six decades of automotive trust for dealership, fleet, bulk and export opportunities.",
    stats: dealerStats,
  },
  formSection: {
    kicker: "GET IN TOUCH",
    title: "Send a WhatsApp Enquiry",
    description:
      "Share a few details and WhatsApp will open with your enquiry ready to send to evLUXE.",
    successTitle: "Thank you.",
    successDescription: "evLUXE will contact you shortly.",
    consent: "I agree to be contacted by evLUXE regarding my enquiry.",
    labels: {
      fullName: "Full Name *",
      phone: "Phone Number *",
      email: "Email",
      city: "City *",
      model: "Preferred Model",
      buyerType: "Buyer Type",
      enquiryType: "Enquiry Type",
      message: "Message",
    },
    placeholders: {
      fullName: "Your full name",
      phone: "10-digit mobile number",
      email: "you@example.com",
      city: "Your city",
      model: "Select model",
      buyerType: "Select type",
      enquiryType: "Select enquiry",
      message: "Tell us how we can help...",
    },
    errors: {
      name: "Please enter your full name.",
      phoneRequired: "Phone number is required.",
      phoneInvalid: "Enter a valid 10-digit Indian mobile number.",
      email: "Enter a valid email address.",
      city: "Please enter your city.",
      consent: "Please provide consent to be contacted.",
    },
    buyerTypes,
    enquiryTypes,
  },
  contactSection: {
    kicker: "CONTACT",
    title: "Reach evLUXE",
    description:
      "Reach us by phone, email, WhatsApp, or visit our offices during business hours.",
    callTitle: "Call Us",
    emailTitle: "Email Us",
    whatsappTitle: "WhatsApp",
    websiteTitle: "Website",
  },
  faqSection: {
    kicker: "FAQ",
    title: "Frequently Asked Questions",
    items: faqs,
  },
  footer: {
    description:
      "Future-ready, premium electric scooters engineered in India for modern roads and sustainable urban mobility.",
    quickLinksTitle: "Quick Links",
    modelsTitle: "Models",
    contactTitle: "Contact",
    copyright: "evLUXE. All rights reserved. Made in India.",
    privacyLabel: "Privacy Policy",
    privacyUrl: "#",
    termsLabel: "Terms",
    termsUrl: "#",
    socialLinks: [
      { platform: "Facebook", url: "#" },
      { platform: "Instagram", url: "#" },
      { platform: "LinkedIn", url: "#" },
      { platform: "YouTube", url: "#" },
    ],
  },
  contact: {
    ...contact,
    whatsappNumber: "917064649494",
  },
};

export const cloneDefaultSiteContent = () =>
  JSON.parse(JSON.stringify(defaultSiteContent));
